import { useState } from 'react'
import ringingBellIcon from '@/assets/userBoxIcons/ring-bell-icon.svg'
import squaredPlusIcon from '@/assets/userBoxIcons/squared-plus-icon.svg'
import personIcon from '@/assets/userBoxIcons/person-icon.svg'

import { useOpeningElementsControllerContext, useUnreadNotificationsCount } from '@/customHooks'
import { DropdownMenu } from './DropDownMenu'
import { NotificationsDropdown } from '../templates/NotificationsDropdown'

export const UserOptionsBox = () => {
  const { logoutConfirmationModalOpen } = useOpeningElementsControllerContext()
  const { unreadCount } = useUnreadNotificationsCount()

  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const options = [
    {
      item: 'Logout',
      action: logoutConfirmationModalOpen,
    },
  ]

  return (
    <div className="relative flex items-center">

      {/* DESKTOP */}
      <div className="hidden md:flex items-center gap-2">

        {/* Plus */}
        <button
          type="button"
          className="relative w-9 h-9 rounded-full flex items-center justify-center hover:bg-white/20"
        >
          <img src={squaredPlusIcon} width={24} alt="announces-area" />
        </button>

        {/* Notifications */}
        <NotificationsDropdown>
          <div className="relative">
            <button
              type="button"
              className="relative w-9 h-9 rounded-full flex items-center justify-center hover:bg-white/20"
            >
              <img src={ringingBellIcon} width={28} alt="notification-area" />
            </button>

            {unreadCount > 0 && (
              <span className="absolute top-[2px] right-[2px] w-[10px] h-[10px] rounded-full bg-red-500 border-2 border-white" />
            )}
          </div>
        </NotificationsDropdown>

        {/* User */}
        <button
          type="button"
          onClick={() => setIsMenuOpen(true)}
          className="relative w-9 h-9 rounded-full flex items-center justify-center hover:bg-white/20"
        >
          <img src={personIcon} width={28} alt="user-options" />
        </button>

        <DropdownMenu
          options={options}
          onOutsideClickAction={() => setIsMenuOpen(false)}
          isOpen={isMenuOpen}
        />

      </div>

      {/* MOBILE MENU BUTTON */}
      <button
        type="button"
        onClick={() => setMobileMenuOpen((prev) => !prev)}
        className="md:hidden w-9 h-9 rounded-full flex items-center justify-center hover:bg-white/20 text-white text-xl"
      >
        ⋮
      </button>

      {/* MOBILE DROPDOWN */}
      {mobileMenuOpen && (
        <div className="absolute right-0 top-12 w-44 bg-white shadow-lg rounded-lg p-2 flex flex-col gap-1 z-50 md:hidden">

          <button className="flex items-center gap-2 px-3 py-2 hover:bg-gray-100 rounded">
            <img src={squaredPlusIcon} width={20} alt="" />
            <span>New</span>
          </button>

          <NotificationsDropdown>
            <button className="flex items-center gap-2 px-3 py-2 hover:bg-gray-100 rounded relative">
              <img src={ringingBellIcon} width={20} alt="" />
              <span>Notifications</span>

              {unreadCount > 0 && (
                <span className="absolute right-2 w-2 h-2 rounded-full bg-red-500" />
              )}
            </button>
          </NotificationsDropdown>

          <button
            onClick={() => {
              setMobileMenuOpen(false)
              setIsMenuOpen(true)
            }}
            className="flex items-center gap-2 px-3 py-2 hover:bg-gray-100 rounded"
          >
            <img src={personIcon} width={20} alt="" />
            <span>User</span>
          </button>

        </div>
      )}

      <DropdownMenu
        options={options}
        onOutsideClickAction={() => setIsMenuOpen(false)}
        isOpen={isMenuOpen}
      />

    </div>
  )
}